/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Get_AccessInputs */

const en_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Access`)
};

const es_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtener acceso`)
};

const fr_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir l'accès`)
};

const de_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugang erhalten`)
};

const ja_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセスを取得`)
};

const zh_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取访问权限`)
};

const ar_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على الوصول`)
};

const id_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan Akses`)
};

const it_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni Accesso`)
};

const ru_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получить доступ`)
};

const pt_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obter Acesso`)
};

const ko_get_access = /** @type {(inputs: Get_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`액세스 권한 얻기`)
};

/**
* | output |
* | --- |
* | "Get Access" |
*
* @param {Get_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const get_access = /** @type {((inputs?: Get_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Get_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_get_access(inputs)
	if (locale === "es") return es_get_access(inputs)
	if (locale === "fr") return fr_get_access(inputs)
	if (locale === "de") return de_get_access(inputs)
	if (locale === "ja") return ja_get_access(inputs)
	if (locale === "zh") return zh_get_access(inputs)
	if (locale === "ar") return ar_get_access(inputs)
	if (locale === "id") return id_get_access(inputs)
	if (locale === "it") return it_get_access(inputs)
	if (locale === "ru") return ru_get_access(inputs)
	if (locale === "pt") return pt_get_access(inputs)
	return ko_get_access(inputs)
});